export class CluPMediaOptions { 
    LAYOUT_MOBILE_VIEW : boolean = false; 
    LAYOUT_MOBILE_VIEW_L : boolean = false;
    LAYOUT_BELOWMONITOR : boolean = false; 
    LAYOUT_BELOWMONITOR_L : boolean = false; 
    LAYOUT_BELOWMONITOR_M : boolean = false; 
    LAYOUT_BELOWMONITOR_L1100 : boolean = false; 
}